import { Container, DottedBanner, SectionTitle } from '@sloyd/ui';
import { Json } from '../../types';
import { Wrapper } from './ContentHireCreator.style';

export type ContentHireCreatorProps = {
  content: Json;
};

export function ContentHireCreator(props: ContentHireCreatorProps) {
  const { content } = props;

  return (
    <Wrapper className='ContentHireCreator-wrapper' data-testid='ContentHireCreator-wrapper'>
      <Container>
        <SectionTitle
          gradient={{ from: '#00f260', to: '#0575e6' }}
          title='🤝 Hire a Creator'
        ></SectionTitle>
        <DottedBanner content={content} />
      </Container>
    </Wrapper>
  );
}

export default ContentHireCreator;
